import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {ROOT_PUBLIC} from '@core/services/routes.service';

@Injectable({
  providedIn: 'root'
})
export class AudioRedirectService implements Resolve<any>{

  constructor(private router: Router) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    sessionStorage.setItem('audioMode', 'true');
    this.router.navigate([ROOT_PUBLIC]);
    return undefined;
  }
}
